import * as React from "react";
import { Button } from "antd";
import { Spin } from "Components/General/Spin";
import { webDavStore } from "./WebDAVStore";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Modal } from "Components/General/Modal/GenericModal";

function editDoc(href: string) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).ITHit.WebDAV.Client.DocManager.EditDocument(href, "/", protocolInstallCallback);
}

function protocolInstallCallback(message?: string) {
  console.log("protocolInstallCallback message: ", message);
  const installerFilePath =
    `/${window.GLOBAL.API_BASE}/lib/Plugins` +
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ITHit.WebDAV.Client.DocManager.GetInstallFileName();
  if (window.confirm("This action requires a protocol installation. Select OK to download the protocol installer.")) {
    window.open(installerFilePath);
  }
}

class WebDAVLibInjector extends React.Component<{ dismiss: () => void }> {
  componentDidMount() {
    const SCRIPT_ID = "it-hit";
    if (document.getElementById(SCRIPT_ID)) {
      this.editFile();
      return;
    }
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = `/${window.GLOBAL.API_BASE}/lib/ITHitWebDAVClient.js`;
    script.async = true;
    script.onload = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).ITHit.WebDAV.Client.LicenseId = "c9ce81bd-5b8e-43bc-b6ae-81cdadb32b90";
      // var ext = self.GetExtension(_58f);
      // var _592 = (ITHit.DetectOS.OS == 'MacOS') ? encodeURIComponent('ofe|u|') : 'ofe|u|';
      // this.OpenProtocol(self.GetMsOfficeSchemaByExtension(ext) + ':' + _592 + _58f, _590);
      this.editFile();
    };
    document.body.appendChild(script);
  }

  async editFile() {
    try {
      const href = await webDavStore.fetch();

      // using ITHit method for browsers detection to avoid CSP for ITHit approach used only for Firefox browsers.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((window as any).ITHit.DetectBrowser.FF) {
        // eslint-disable-line @typescript-eslint/no-explicit-any
        const ITHit = (window as any).ITHit; // eslint-disable-line @typescript-eslint/no-explicit-any
        const getExtension = ITHit.WebDAV.Client.DocManager.GetExtension;
        const getMsOfficeSchemaByExtension = ITHit.WebDAV.Client.DocManager.GetMsOfficeSchemaByExtension;
        const activeXSnippet = "ofe|u|";
        const activeXUrl = getMsOfficeSchemaByExtension(getExtension(href)) + ":" + activeXSnippet + href;
        // because CSP strictly disables "ms-excel:ofe|u|https://..." stuff in iframe urls - we use window.open;
        window.open(activeXUrl, "_blank");
      } else {
        editDoc(href);
      }

      this.props.dismiss();
    } catch (error) {
      throw error;
    }
  }

  render() {
    return (
      <div className="text-center">
        <Spin tip={"Please wait. Preparing WebDAV interface."} />
      </div>
    );
  }
}

interface WebDAVModalProps extends WithTranslation {}

export const WebDAVModal = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<WebDAVModalProps> {
      render() {
        const { t } = this.props;
        return (
          <Modal
            title={t("Loading...")}
            open={webDavStore.isVisible}
            destroyOnHidden={true}
            onCancel={webDavStore.hideModal}
            maskClosable={false}
            closable={false}
            footer={
              <div className="text-right">
                <Button onClick={webDavStore.hideModal}>{t("Cancel")}</Button>
              </div>
            }
          >
            <WebDAVLibInjector dismiss={webDavStore.hideModal} />
          </Modal>
        );
      }
    }
  )
);
